export const PAGE_DETAIL = 121;
export const PAGE_SEARCH = 31;
export const PAGE_MANUFACTURERS = 51;
export const PAGE_COUNTRIES = 106;
